import * as $ from 'jquery';
import { reject } from 'lodash';

/* eslint-disable */
// utility dependencies generated by coffeescript
const indexOf =
    [].indexOf ||
    function (item) {
      for (let i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) {
          return i;
        }
      }
      return -1;
    },
  slice = [].slice,
  bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  hasProp = {}.hasOwnProperty;

/**
 * Pivot Table Renderer
 *
 * Originally generated from coffeescript
 *
 * @inspiredby https://github.com/nicolaskruchten/pivottable/blob/2f43137/dist/pivot.js#L739
 * @param pivotData
 * @param opts
 * @returns {HTMLTableElement|HTMLElement|any}
 */
export function pivotTableRenderer(pivotData, opts) {
  let mainHeader,
    aggregator,
    c,
    colAttrs,
    colKey,
    colKeys,
    defaults,
    div,
    i,
    j,
    k,
    r,
    result,
    rowAttrs,
    rowKey,
    rowKeys,
    spanSize,
    tbody,
    td,
    th,
    thead,
    totalAggregator,
    tr,
    txt,
    val,
    x;
  defaults = {
    localeStrings: {
      totals: 'Totals',
    },
  };
  opts = $.extend(defaults, opts);
  colAttrs = pivotData.colAttrs;
  rowAttrs = pivotData.rowAttrs;
  rowKeys = pivotData.getRowKeys();
  colKeys = pivotData.getColKeys();
  result = document.createElement('table');
  result.className = 'pvtTable';
  spanSize = function (arr, i, j) {
    let l, len, n, noDraw, ref, ref1, stop, x;
    if (i !== 0) {
      noDraw = true;
      for (x = l = 0, ref = j; 0 <= ref ? l <= ref : l >= ref; x = 0 <= ref ? ++l : --l) {
        if (arr[i - 1][x] !== arr[i][x]) {
          noDraw = false;
        }
      }
      if (noDraw) {
        return -1;
      }
    }
    len = 0;
    while (i + len < arr.length) {
      stop = false;
      for (x = n = 0, ref1 = j; 0 <= ref1 ? n <= ref1 : n >= ref1; x = 0 <= ref1 ? ++n : --n) {
        if (arr[i][x] !== arr[i + len][x]) {
          stop = true;
        }
      }
      if (stop) {
        break;
      }
      len++;
    }
    return len;
  };
  thead = document.createElement('thead');

  /**
   * @param arr
   * @param prop
   * @param reverse
   * @returns {any}
   */
  const filterConsecutiveDupes = (arr, prop, reverse = false) => {
    const result = rejectConsecutiveDupes(arr, prop);
    return result;
  };

  var rejectConsecutiveDupes = (arr, prop) =>
    reject(arr, function (o, i: number) {
      return i > 0 && arr[i - 1][prop] === o[prop];
    });

  // find table body column span
  const upperBoundKeys = (keys, index = 0, indexOffset = 0) =>
    filterConsecutiveDupes(
      keys.map((key, i) => ({ key: key[index], index: i + indexOffset })),
      'key'
    );

  const lowerBoundKeys = (keys, index = 0, indexOffset = 0) =>
    filterConsecutiveDupes(
      keys.map((key, i) => ({ key: key[index], index: i + indexOffset })).reverse(),
      'key',
      true
    ).reverse();

  const bodySpan = upperBoundKeys(colKeys)
    .map((o: { key; index }) => spanSize(colKeys, o.index, 0))
    .reduce((a, b) => a + b, 0);

  const boundaries = function (keys, attrs, lower = false) {
    const initial: Array<{ key; index }> = <Array<{ key; index }>>lowerBoundKeys(keys);
    const getBoundKeys = !lower ? upperBoundKeys : lowerBoundKeys;

    return attrs.map((attr, i) => {
      if (initial) {
        return initial.map((o: { key; index }, oIndex) => {
          let subThing, start, end, newKeys;
          const index = o.index;
          const prevIndex = initial[oIndex - 1];

          if (prevIndex === void 0) {
            start = 0;
          } else if (prevIndex.index >= 0) {
            start = prevIndex.index + 1;
          }
          end = index + 1;
          newKeys = keys.slice(start, end);
          return getBoundKeys(newKeys, i, start).slice(-1)[0];
        });
      }
    }, []);
  };

  const boundaryLookup = function (bounds) {
    let result = [];

    if (bounds.length) {
      result = bounds[0].map((v, i) =>
        bounds.map((arr) => arr.map((o) => o.index)).reduce((accu, prev) => accu.push(prev[i]) && accu, [])
      );
    }

    return result;
  };

  const valueDefaults = function (value) {
    return pivotData.valAttrs.length ? value : '';
  };

  const rowHeaderBoundaryLookup = boundaryLookup(boundaries(rowKeys, rowAttrs));

  const rowBodyBoundaryLookup = boundaryLookup([lowerBoundKeys(rowKeys)]);

  const colHeaderBoundaryLookup = boundaryLookup(boundaries(colKeys, colAttrs));

  const colBodyBoundaryLookup = boundaryLookup([lowerBoundKeys(colKeys)]);

  const rowDividers = rowAttrs.length > 1;
  const colDividers = colAttrs.length > 1;

  const pvtJoint = function (omitSpanning = false) {
    const th = document.createElement('th');

    th.className = 'pvtJoint pvtAxisLabel pvtNoSort';
    if (!omitSpanning) {
      th.setAttribute('colspan', rowAttrs.length);
      th.setAttribute('rowspan', colAttrs.length);
    }
    th.appendChild(fixedHeader('  '));
    return th;
  };

  let eligibleForRender = true;

  if (opts.beforeRender) {
    eligibleForRender = opts.beforeRender({
      rowCount: rowKeys.length,
      colCount: colKeys.length,
    });
  }

  if (!eligibleForRender) {
    return result;
  }

  for (j in colAttrs) {
    if (!hasProp.call(colAttrs, j) || typeof colAttrs[j] === 'function') {
      continue;
    }
    c = colAttrs[j];
    // add first row
    if (parseInt(j) === 0 && colAttrs.length !== 0) {
      tr = document.createElement('tr');
      if (colAttrs.length > 1) {
        th = document.createElement('th');
        div = document.createElement('div');
        div.className = 'pvtMainHeaderWrapper pvtFixedHeader';
        mainHeader = document.createElement('div');
        mainHeader.className = 'pvtMainHeaderContainer';
        div.appendChild(mainHeader);
        th.className = 'pvtMainHeader pvtAxisLabel pvtNoSort';
        th.setAttribute('colspan', rowAttrs.length + bodySpan + 1);
        th.appendChild(div);
        tr.appendChild(th);
      } else {
        mainHeader = tr;
        th = pvtJoint(true);
        tr.appendChild(th);
        for (k in rowAttrs) {
          if (parseInt(k) > 0) {
            th = document.createElement('th');
            th.className = 'pvtAxisLabel pvtNoSort';
            if (parseInt(k) === rowAttrs.length - 1) {
              th.className += ' pvtDividerVertical';
            }
            th.appendChild(fixedHeader(' '));
            tr.appendChild(th);
          }
        }
      }
      thead.appendChild(tr);
    }
    tr = document.createElement('tr');
    if (parseInt(j) === 0 && rowAttrs.length !== 0 && colAttrs.length > 1) {
      // blank axis corner
      th = pvtJoint(true);
      tr.appendChild(th);
      for (k in rowAttrs.slice(1)) {
        th = document.createElement('th');
        th.className = 'pvtAxisLabel pvtNoSort';
        if (parseInt(k) === rowAttrs.length - 2) {
          th.className += ' pvtDividerVertical';
        }
        if (colAttrs.length === 1 && rowAttrs.length > 0) {
          th.className += ' pvtHideHeader';
        }
        th.appendChild(fixedHeader(' '));
        tr.appendChild(th);
      }
    } else {
      // filler cells
      // default to at least one axis label
      for (k = 0; k < Math.max(rowAttrs.length, 1); k++) {
        th = document.createElement('th');
        th.className = 'pvtAxisLabel pvtNoSort';
        if (colAttrs.length === 1 && rowAttrs.length > 0) {
          th.className += ' pvtHideHeader';
        }
        if ((parseInt(k) === rowAttrs.length - 1 || !rowAttrs.length) && colDividers) {
          th.className += ' pvtDividerVertical';
        }
        th.appendChild(fixedHeader(' '));
        tr.appendChild(th);
      }
    }
    th = document.createElement('th');
    th.className = 'pvtAxisLabel';
    th.setAttribute('data-col-key', '');
    th.setAttribute('data-axis-key', $.trim(c));
    if (colAttrs.length === 1) {
      th.appendChild(fixedHeader(c));
      th.setAttribute('colspan', bodySpan + 1);
    } else {
      // disable header positioning if more than one header
      th.appendChild(fixedHeader(c, true));
    }
    mainHeader.appendChild(th);
    for (i in colKeys) {
      if (!hasProp.call(colKeys, i)) {
        continue;
      }
      colKey = colKeys[i];
      x = spanSize(colKeys, parseInt(i), parseInt(j));
      if (x !== -1) {
        th = document.createElement('th');
        th.className = 'pvtColLabel';
        th.setAttribute('colspan', x);
        if (parseInt(j) === colAttrs.length - 1 && rowAttrs.length !== 0) {
          th.setAttribute('rowspan', 2);
        }
        if (colHeaderBoundaryLookup.some((arr) => arr[parseInt(j)] == i) && colDividers) {
          th.className += ' pvtDividerVertical';
        }
        th.setAttribute('data-col-attr', $.trim(colKey[j]));
        th.appendChild(fixedHeader(colKey[j]));
        tr.appendChild(th);
      }
    }
    if (parseInt(j) === 0) {
      th = document.createElement('th');
      th.className = 'pvtTotalLabel';
      th.setAttribute('rowspan', colAttrs.length + (rowAttrs.length === 0 ? 0 : 1));
      th.appendChild(fixedHeader(opts.localeStrings.totals));
      tr.appendChild(th);
    }
    thead.appendChild(tr);
  }
  if (rowAttrs.length !== 0) {
    tr = document.createElement('tr');
    for (i in rowAttrs) {
      if (!hasProp.call(rowAttrs, i) || typeof rowAttrs[i] === 'function') {
        continue;
      }
      r = rowAttrs[i];
      th = document.createElement('th');
      th.className = 'pvtAxisLabel';
      th.setAttribute('data-row-key', '');
      th.setAttribute('data-axis-key', $.trim(r));
      th.appendChild(fixedHeader(r));
      tr.appendChild(th);
    }
    if (colAttrs.length === 0) {
      th = document.createElement('th');
      th.className = 'pvtTotalLabel';
      th.setAttribute('data-key', opts.localeStrings.totals);
      th.appendChild(fixedHeader(opts.localeStrings.totals));
      tr.appendChild(th);
    }
    thead.appendChild(tr);
  }
  result.appendChild(thead);
  tbody = document.createElement('tbody');
  // super hack to get dividers to play nice
  const defer = [];
  for (i in rowKeys) {
    if (!hasProp.call(rowKeys, i)) {
      continue;
    }
    rowKey = rowKeys[i];
    tr = document.createElement('tr');
    for (j in rowKey) {
      if (!hasProp.call(rowKey, j)) {
        continue;
      }
      txt = rowKey[j];
      x = spanSize(rowKeys, parseInt(i), parseInt(j));
      if (x !== -1) {
        th = document.createElement('th');
        th.className = 'pvtRowLabel';
        if ((rowHeaderBoundaryLookup.some((arr) => arr[parseInt(j)] == i) || defer[j]) && rowDividers) {
          if (x === 1 && !defer[j]) {
            defer[j] = true;
          }

          if (defer && rowBodyBoundaryLookup.some((arr) => arr[0] == i)) {
            defer[j] = false;
          }

          if (!defer[j]) {
            th.className += ' pvtDivider';
          }
        }
        th.setAttribute('rowspan', x);
        th.setAttribute('data-row-attr', $.trim(txt));
        th.appendChild(fixedHeader(txt));
        tr.appendChild(th);
      }
    }
    for (j in colKeys) {
      if (!hasProp.call(colKeys, j)) {
        continue;
      }
      colKey = colKeys[j];
      aggregator = pivotData.getAggregator(rowKey, colKey);
      val = valueDefaults(aggregator.value());
      td = document.createElement('td');
      td.className = 'pvtVal row' + i + ' col' + j;
      if (rowBodyBoundaryLookup.some((arr) => arr[0] == i) && rowDividers) {
        td.className += ' pvtDivider';
      }
      if (colBodyBoundaryLookup.some((arr) => arr[0] == j) && colDividers) {
        td.className += ' pvtDividerVertical';
      }
      td.textContent = aggregator.format(val);
      td.setAttribute('data-value', val);
      tr.appendChild(td);
    }
    totalAggregator = pivotData.getAggregator(rowKey, []);
    val = valueDefaults(totalAggregator.value());
    td = document.createElement('td');
    td.className = 'pvtTotal rowTotal';
    if (rowBodyBoundaryLookup.some((arr) => arr[0] == i) && rowDividers) {
      td.className += ' pvtDivider';
    }
    td.textContent = totalAggregator.format(val);
    td.setAttribute('data-value', val);
    td.setAttribute('data-for', 'row' + i);
    tr.appendChild(td);
    tbody.appendChild(tr);
  }
  tr = document.createElement('tr');
  // filler cells
  for (k in rowAttrs.slice(1)) {
    if (!hasProp.call(rowAttrs, k) || typeof rowAttrs[k] === 'function') {
      continue;
    }
    th = document.createElement('th');
    th.className = 'pvtRowLabel pvtTotalFillerLabel pvtNoSort';
    th.appendChild(fixedHeader(' '));
    tr.appendChild(th);
  }
  th = document.createElement('th');
  th.className = 'pvtTotalLabel';
  th.setAttribute('data-key', opts.localeStrings.totals);
  th.appendChild(fixedHeader(opts.localeStrings.totals));
  tr.appendChild(th);
  for (j in colKeys) {
    if (!hasProp.call(colKeys, j)) {
      continue;
    }
    colKey = colKeys[j];
    totalAggregator = pivotData.getAggregator([], colKey);
    val = valueDefaults(totalAggregator.value());
    td = document.createElement('td');
    td.className = 'pvtTotal colTotal';
    if (colBodyBoundaryLookup.some((arr) => arr[0] == j) && colDividers) {
      td.className += ' pvtDividerVertical';
    }
    td.textContent = totalAggregator.format(val);
    td.setAttribute('data-value', val);
    td.setAttribute('data-for', 'col' + j);
    tr.appendChild(td);
  }
  totalAggregator = pivotData.getAggregator([], []);
  val = valueDefaults(totalAggregator.value());
  td = document.createElement('td');
  td.className = 'pvtGrandTotal';
  td.textContent = totalAggregator.format(val);
  td.setAttribute('data-value', val);
  tr.appendChild(td);
  tbody.appendChild(tr);
  result.appendChild(tbody);
  result.setAttribute('data-numrows', rowKeys.length);
  result.setAttribute('data-numcols', colKeys.length);
  return result;
}

function fixedHeader(str, disable?) {
  const div = document.createElement('div');
  const span = document.createElement('span');

  div.className = 'pvtFixedHeader';
  div.className += disable ? ' pvtFixedHeaderNoFollow' : '';
  div.setAttribute('title', str);
  span.className = 'table-header-label';
  span.textContent = str;
  div.appendChild(span);
  return div;
}
